module.exports = function getResource(label, vars = []) {
    const resources = {
        freeShipping: 'You now qualify for free shipping!'
    };

    return resources[label];
};
